import { postReactionParticipantsGQLFields, } from './post-reaction-participant.fields.js';
import { postGQLFields } from './posts.fields.js';
const BASIC_POST_LAST_ACTIVITY_ENTITY_FIELDS = {};
const ALL_POST_LAST_ACTIVITY_ENTITY_FIELDS = {
    onPost: 'basic',
    onPostReactionParticipant: 'basic',
};
export const postLastActivityEntityGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_POST_LAST_ACTIVITY_ENTITY_FIELDS;
    if (fields === 'all')
        fields = ALL_POST_LAST_ACTIVITY_ENTITY_FIELDS;
    return `
    __typename
    ${fields.onPost
        ? `
      ... on Post {
        ${postGQLFields(fields.onPost)}
      }
    `
        : ``}
    ${fields.onPostReactionParticipant
        ? `
      ... on PostReactionParticipant {
        ${postReactionParticipantsGQLFields(fields === null || fields === void 0 ? void 0 : fields.onPostReactionParticipant)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=post-last-activity-entity.fields.js.map